import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class Hsn.HsnCaresDisclaimerModal
* 
* Encapsulates the functionality of a modal dialog that contains the HSN Cares Drive disclaimer info
**/
HSN.HsnCaresDisclaimerModal = (function(_super) {
    __extends(HsnCaresDisclaimerModal, _super);

    //new Hsn.HsnCaresDisclaimerModal()
    function HsnCaresDisclaimerModal() {
        this.elementName = '#';
        this.name = 'HSN.HsnCaresDisclaimerModal';

        return HsnCaresDisclaimerModal.__super__.constructor.call(this);
    }

    HsnCaresDisclaimerModal.prototype._hide = function() {};

    /**
    * HSN.HsnCaresDisclaimerModal#Show(disclaimer) -> void
    * - disclaimer (string): The disclaimer to show inside of the modal...
    *
    * Display the modal and load in the disclaimer string
    **/
    HsnCaresDisclaimerModal.prototype._show = function(disclaimer) {
        var __scope = this;

        var htmlStyle = "<style>.articletext {width: 600px;padding: 10px;color: #666; font-family: Helvetica, Arial; font-size:12px; line-height:22px;}" +
            "#breadbox: {display:none;}" +
            "@media screen and (max-width: 500px) {div.articletext {width: auto;}}</style>";

        var htmlContent = '<div align="left" class="articletext"><p>' + disclaimer + '</p></div>';

        var htmlToDisplay = htmlStyle + htmlContent;

        __scope.Root.removeClass('loading');
        __scope.DisplayModal(htmlToDisplay, 0);
    };

    HsnCaresDisclaimerModal.prototype.DisplayModal = function(data, time) {
        var __scope = this;

        this.Content.showHtml(data, time,
            function() {
                __scope.Center();
                __scope.Content.animate({ opacity : 1 });
            },
            function() {

            });
    };

    return HsnCaresDisclaimerModal;

})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/HsnCaresDisclaimerModal.js